export const GET_PROJECT_INTERESTED_ATTEMPT = 'GET_PROJECT_INTERESTED_ATTEMPT';
export type GET_PROJECT_INTERESTED_ATTEMPT = typeof GET_PROJECT_INTERESTED_ATTEMPT;

export const GET_PROJECT_INTERESTED_SUCCESS = 'GET_PROJECT_INTERESTED_SUCCESS';
export type GET_PROJECT_INTERESTED_SUCCESS = typeof GET_PROJECT_INTERESTED_SUCCESS;

export const GET_PROJECT_INTERESTED_FAILURE = 'GET_PROJECT_INTERESTED_FAILURE';
export type GET_PROJECT_INTERESTED_FAILURE = typeof GET_PROJECT_INTERESTED_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/interested/get/Types.tsx